import type { GlobalFeatureFlagsMap } from './domain/globalFeatureFlags';

/** Mirror of isGlobalFeatureOn for this key (fail-open). Kept local to avoid RN imports in tests. */
function isPublicStoreFlagOn(flags: GlobalFeatureFlagsMap | null | undefined): boolean {
  if (!flags) return true;
  return flags.public_store_features !== false;
}

/** Cualquier rubro puede configurar tienda online. El dueño reparte el link. */
export function isPublicStoreBusinessTypeAllowed(
  _businessTypeCode?: string | null,
): boolean {
  return true;
}

export function isPublicStoreFeaturesVisible(
  flags: GlobalFeatureFlagsMap | null | undefined,
  businessTypeCode?: string | null,
  storefrontEnabled = true,
): boolean {
  if (storefrontEnabled === false) return false;
  if (!isPublicStoreFlagOn(flags)) return false;
  return isPublicStoreBusinessTypeAllowed(businessTypeCode);
}
